import React from "react";

export default function InterdicaoDetalhesViaFields({
  Section,
  ReadOnlyField,
  formatDate,
  interdicao,
  resolveValue,
}) {
  return (
    <>
      <Section title="Operação">
        <div className="interdDet-grid interdDet-grid--3">
          <ReadOnlyField label="Data" value={formatDate(interdicao.dataInicio)} />
          <ReadOnlyField label="Horário início" value={interdicao.horaInicio || "-"} />
          <ReadOnlyField
            label="Seção de Bloqueio"
            value={resolveValue("sb", "sbParada") || "-"}
          />
          <ReadOnlyField label="SUB" value={resolveValue("sub") || "-"} />
          <ReadOnlyField label="KM de trabalho" value={resolveValue("kmInicial", "km") || "-"} />
        </div>
      </Section>

      <Section title="Identificação">
        <div className="interdDet-grid interdDet-grid--3">
          <ReadOnlyField label="Identificador" value={resolveValue("identificador") || "-"} />
          <ReadOnlyField label="Acionamento" value={resolveValue("acionamento") || "-"} />
          <ReadOnlyField
            label="Nível de Acionamento"
            value={resolveValue("nivelAcionamento", "nivel_acionamento") || "-"}
          />
          <ReadOnlyField label="Motivo" value={resolveValue("motivo") || "-"} />
          <ReadOnlyField
            label="Observação"
            value={resolveValue("observacao") || "-"}
            wide
            multiline
          />
        </div>
      </Section>
    </>
  );
}
